module.exports = __webpack_public_path__ + "static/media/GARBAGE.89ea3221.svg";